import { IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import SquareEditOutlineIcon from 'mdi-react/SquareEditOutlineIcon';
import React, { memo } from 'react';
import { useListVisibleQuery } from 'store/app/entities/EmployeesApiSlice';
import direct from 'store/app/ui/drawers/direct/action';
import useActions from 'utils/useActions';

const DirectButton = () => {
  const theme = useTheme();
  const openDirectDrawer = useActions(direct.open);
  const { data: { metadata } = {}, isLoading } = useListVisibleQuery({
    skip: 0,
    limit: 99,
    search: '',
  }); // Keep these parameters to match the DirectDrawer query and prevent an additional call
  if (isLoading || !metadata?.total) {
    return null;
  }
  return (
    <IconButton onClick={openDirectDrawer} size="large">
      <SquareEditOutlineIcon color={theme.palette.primary.main} />
    </IconButton>
  );
};

export default memo(DirectButton);
